import axios from 'axios';

/**
 * Requisição abortada via AbortController / cancelamento Axios — não é falha de negócio.
 */
export function isAxiosRequestCanceled(error) {
    if (!error) {
        return false;
    }

    if (typeof axios.isCancel === 'function' && axios.isCancel(error)) {
        return true;
    }

    if (error.code === 'ERR_CANCELED') {
        return true;
    }

    const name = error.name;
    if (name === 'CanceledError' || name === 'Cancel' || name === 'Canceled') {
        return true;
    }

    return error.message === 'canceled';
}

/**
 * Timeout de rede/cliente (ECONNABORTED / ETIMEDOUT) — tratar na UI, não como bug no Sentry.
 */
export function isAxiosTimeout(error) {
    if (!error) {
        return false;
    }

    const code = error.code;
    if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') {
        return true;
    }

    const msg = typeof error.message === 'string' ? error.message : '';
    return /timeout/i.test(msg);
}

/** Sem resposta HTTP: timeout, offline ou conexão interrompida. */
export function isAxiosNetworkOrTimeoutError(error) {
    if (!error?.response) {
        return isAxiosTimeout(error) || error?.code === 'ERR_NETWORK';
    }
    return false;
}
